"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _CircularProgress = _interopRequireDefault(require("@mui/material/CircularProgress"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _SNETDialog = _interopRequireDefault(require("../SNETDialog"));
var _SNETLoaderModule = _interopRequireDefault(require("./SNETLoader.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SNETLoader = _ref => {
  let {
    isLoading,
    title = "Please, wait",
    content
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SNETDialog.default, {
    isDialogOpen: isLoading,
    title: title,
    showCloseButton: false,
    children: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: _SNETLoaderModule.default.circularProgressContainer
    }, /*#__PURE__*/_react.default.createElement(_CircularProgress.default, {
      className: _SNETLoaderModule.default.circularProgress
    })), /*#__PURE__*/_react.default.createElement(_Typography.default, {
      className: _SNETLoaderModule.default.loaderContent,
      variant: "body2",
      component: "p"
    }, content)),
    contentClass: _SNETLoaderModule.default.card
  });
};
SNETLoader.propTypes = {
  isLoading: _propTypes.default.bool.isRequired,
  title: _propTypes.default.string.isRequired,
  content: _propTypes.default.string
};
var _default = exports.default = SNETLoader;